import { apiRequest } from './http';
import type { SaveUserRequest, UserSummary } from './types';

const usersPath = '/api/manage/users';

export interface UsersResponse {
  items: UserSummary[];
  roles: string[];
}

export async function listUsers(): Promise<UsersResponse> {
  const response = await apiRequest<Partial<UsersResponse>>(usersPath);
  return { items: response.items ?? [], roles: response.roles ?? [] };
}

export async function saveUser(request: SaveUserRequest, existingEmail?: string): Promise<UserSummary> {
  return apiRequest<UserSummary>(existingEmail ? `${usersPath}/${encodeURIComponent(existingEmail)}` : usersPath, {
    method: existingEmail ? 'PUT' : 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(request)
  });
}

export async function deleteUser(email: string): Promise<void> {
  await apiRequest<void>(`${usersPath}/${encodeURIComponent(email)}`, { method: 'DELETE' });
}
